import React from 'react';
import { AlertContext } from './alert.context';

export function useAlert() {
  return { showAlert: React.useContext(AlertContext) };
}
